import { Component } from '@angular/core';
import { Router } from '@angular/router';

import '../style/app.scss';

@Component({
  selector: 'sa-app', // <sa-app></sa-app>
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')],
})
export class AppComponent {
  constructor(public router: Router) {
  }

  isLoginRoute(): boolean {
    return this.router.url === '/login';
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/app.component.ts